var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{staticClass:"AppTextArea form-control",attrs:{"name":_vm.name,"rows":_vm.rows,"readonly":_vm.readOnly},domProps:{"value":_vm.value},on:{"input":_vm.changed}})
}
var staticRenderFns = []

export { render, staticRenderFns }